import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, serializeDataIfNeeded, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CandidatePublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 후보자 등록
     * @param {CandidatePublicControllerApiRegisterCandidateForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCandidateForPublic: ({ jobDescriptionIdHash, candidatePublicCreateRequest }, options = {}) => {
      assertParamExists("registerCandidateForPublic", "jobDescriptionIdHash", jobDescriptionIdHash);
      assertParamExists("registerCandidateForPublic", "candidatePublicCreateRequest", candidatePublicCreateRequest);
      const localVarPath = "/api-public/v2/recruiting/job-descriptions/{jobDescriptionIdHash}/register-candidate".replace("{".concat("jobDescriptionIdHash", "}"), encodeURIComponent(String(jobDescriptionIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(candidatePublicCreateRequest, localVarRequestOptions, configuration);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "registerCandidateForPublic",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const CandidatePublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = CandidatePublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 후보자 등록
     * @param {CandidatePublicControllerApiRegisterCandidateForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCandidateForPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.registerCandidateForPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const CandidatePublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = CandidatePublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @summary 후보자 등록
     * @param {CandidatePublicControllerApiRegisterCandidateForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCandidateForPublic(requestParameters, options) {
      return localVarFp.registerCandidateForPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class CandidatePublicControllerApi extends BaseAPI {
  /**
   * 
   * @summary 후보자 등록
   * @param {CandidatePublicControllerApiRegisterCandidateForPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CandidatePublicControllerApi
   */
  registerCandidateForPublic(requestParameters, options) {
    return CandidatePublicControllerApiFp(this.configuration).registerCandidateForPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const registerCandidateForPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: CandidatePublicControllerApiAxiosParamCreator().registerCandidateForPublic,
  requestFn: CandidatePublicControllerApiFp().registerCandidateForPublic
});

export { CandidatePublicControllerApi, CandidatePublicControllerApiAxiosParamCreator, CandidatePublicControllerApiFactory, CandidatePublicControllerApiFp, registerCandidateForPublicRemote };
//# sourceMappingURL=candidate-public-controller-api.mjs.map
